import styled from 'styled-components';

export const H2 = styled.h2`
  font-size: 3rem;
  line-height: 4rem;
  margin: 1.2rem 0;
  font-weight: normal;
  text-rendering: optimizelegibility;
  text-align: center;
`;

export const H3 = styled.h3`
  font-size: 2.4rem;
  line-height: 4rem;
  margin: 1.2rem 0;
  font-weight: normal;
  text-rendering: optimizelegibility;
  text-align: center;
`;

export const H4 = styled.h4`
  font-size: 1.8rem;
  margin: 1.2rem 0;
  font-family: ${p => p.theme.primaryFontFamily};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  text-rendering: optimizelegibility;
`;

export const PhoneNumber = styled.a`
  margin-left: 1rem;
`;



// WEBPACK FOOTER //
// ./styles/components/typography.style.js